import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { handleCardKnoxForm, getCardKnoxState } from "@actions/cardKnox";
import { defaultAction } from "@actions/defaultAction";
import {
  UPDATE_BUY_CART_ERROR_MSG,
  CLEAR_CARD_KNOX,
  SET_CARD_KNOX_SUBMITTING,
  SET_CARD_KNOX_LOADED
} from "@constants/actionTypes";
import styled from "@emotion/styled";
import SmallSpinner from "@components/SmallSpinner";
import StyledCheckbox from "@components/forms/StyledCheckbox";
import CustomerAddressForm from "@components/CustomerAddressForm";
import { FormSection } from "redux-form";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import { loadScripts } from "@helpers/loadScripts";
import { Field } from "redux-form";
import RenderFormFieldNew from "./RenderFormFieldNew";
import { expirationDate } from "@components/validation";
import { normalizeMonthAndYear } from "@components/validation/normalize";
import { getCardknoxData } from "@actions/getCardKnoxToken";
import {
  CARDKNOX_IFIELDS_KEY,
  CARDKNOX_IFIELDS_VERSION
} from "@constants/cardknox";

const MainContainer = styled.div`
  position: relative;
`;

const Container = styled.div`
  position: relative;
  opacity: ${props => props.setOpacity};
`;

const InputWrapper = styled.div`
  position: relative;
`;

const InputContainer = styled.div`
  height: 72px;
  border-radius: 5px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  box-shadow: ${props =>
    props.errorState
      ? "0 20px 70px 0 rgba(31, 32, 33, 0.05)"
      : "0 20px 70px 0 rgba(31, 32, 33, 0.12)"};
  border: ${props => props.setBorder};
`;

const FieldContainer = styled.div`
  height: 72px;
  position: relative;
  overflow: hidden;
  visibility: ${props => props.setVisibility};
`;

const InputContainerGrid = styled(InputContainer)`
  display: grid;
  padding-left: 20px;
  grid-template-columns: 32px 1fr;
  margin-bottom: 20px;
`;

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 10px;
  @media (max-width: 375px) {
    grid-template-columns: 1fr;
    grid-gap: 17px;
  }
`;

const Image = styled.img`
  opacity: 0.3;
  align-self: center;
`;

const LockImage = styled(Image)`
  width: 16px;
`;

const Absolutecontainer = styled.div`
  top: 4px;
  position: absolute;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  left: 22px;
  text-transform: uppercase;
  @media (max-width: 530px) {
    font-size: 9px;
  }
  @media (max-width: 465px) {
    font-size: 8px;
  }
`;

const ErrorContainer = styled(Absolutecontainer)`
  color: #ee5050;
`;

const Title = styled(Absolutecontainer)`
  color: rgba(31, 32, 33, 0.5);
`;

const CheckboxContainer = styled.div`
  margin-bottom: 15px;
`;

const Header = styled.div`
  font-weight: 500;
  color: rgba(119, 121, 132, 1);
  font-size: 17px;
  margin-bottom: 15px;
`;

const CardKnox = ({
  updateErrorMsg,
  checkboxName,
  handleSaveAndContinue,
  cardKnoxSubmitting,
  invalid = false,
  ccServerError,
  changeCcserverError,
  setClassName,
  billingCheckboxName,
  billingValid,
  formData,
  buttonType = "ORANGE_BUTTON",
  submitText = "Save & Continue",
  missingInfo,
  handleCardKnoxForm,
  getCardKnoxState,
  getCardknoxData,
  cardKnox,
  setCardKnoxSubmission,
  clearForm,
  setCardKnoxLoaded
}) => {
  const [loadCount, setLoadCount] = useState(0);
  useEffect(() => {
    loadScripts(
      `https://cdn.cardknox.com/ifields/${CARDKNOX_IFIELDS_VERSION}/ifields.min.js`,
      "cardKnox",
      scriptLoaded
    );
    return () => {
      removeEventListener("click", handleSubmission);
      clearForm();
      setCardKnoxLoaded(false);
    };
  }, []);

  const scriptLoaded = existing => {
    updateErrorMsg("");
    var submitBtn = document.getElementById("submit-btn");
    if (!existing) {
      let style = {
        border: "none",
        fontSize: "16px",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        outline: "none",
        height: "72px",
        fontFamily: "Montserrat, DejaVu Sans, Verdana, sans‑serif"
      };
      setIfieldStyle("card-number", style);
      setIfieldStyle("cvv", style);
      enableAutoFormatting();

      addIfieldCallback("focus", handleFocus);
      addIfieldCallback("blur", handleBlur);
      addIfieldCallback("input", handleChange);
      setAccount(CARDKNOX_IFIELDS_KEY, "cardcash_ifields", "1.0.0");
    }
    submitBtn.addEventListener("click", handleSubmission);
  };

  const handleFocus = e => {
    handleCreditBlur(e);
  };
  const handleChange = e => {
    handleCreditBlur(e);
  };
  const handleBlur = e => {
    handleCreditBlur(e);
  };

  const handleSubmission = async () => {
    try {
      const cardKnoxState = await getCardKnoxState();
      if (!cardKnoxState.submitting) {
        setCardKnoxSubmission(true);

        const { cardNumToken, cvvNumToken } = await getCardknoxData();
        handleSaveAndContinue(cardNumToken, cvvNumToken);
      }
    } catch (error) {
      changeCcserverError(error.message);
      throw error;
    }
  };

  const handleCreditBlur = async event => {
    const cardKnoxState = await getCardKnoxState();
    const field = { touched: true };
    let cvvIsProvenValid = cardKnoxState.cvvIsProvenValid;
    let cvvIsProvenInvalid = cardKnoxState.cvvIsProvenInvalid;

    if (event.event === "blur") {
      field.initialTouch = false;
      field.isFocused = false;
    } else if (event.event === "focus") {
      field.isFocused = true;
    } else if (event.event === "input" && event.cardNumberIsValid) {
      switch (event.issuer) {
        case "amex":
          if (event.cvvLength === 4) {
            cvvIsProvenValid = true;
            cvvIsProvenInvalid = false;
          } else {
            cvvIsProvenInvalid = true;
            cvvIsProvenValid = false;
          }
          break;

        default:
          if (event.cvvLength === 3) {
            cvvIsProvenValid = true;
            cvvIsProvenInvalid = false;
          } else {
            cvvIsProvenInvalid = true;
            cvvIsProvenValid = false;
          }
          break;
      }
    }
    switch (event.triggeredByIfield) {
      case "card-number":
        field.isEmpty = event.cardNumberIsEmpty;
        field.isValid = event.cardNumberIsValid;
        break;
      case "cvv":
        field.isEmpty = event.cvvIsEmpty;
        field.isValid = event.cvvIsValid;
        break;
      default:
        break;
    }

    const changedObject = {
      [event.triggeredByIfield]: {
        ...cardKnoxState[event.triggeredByIfield],
        ...field
      },
      ...event,
      cvvIsProvenValid,
      cvvIsProvenInvalid
    };
    handleCardKnoxForm(changedObject);
  };

  const loadIframe = type => {
    const placeholder = type === "cvv" ? "CVV" : "Card Number";
    return (
      <iframe
        onLoad={() => {
          const count = loadCount + 1;
          if (count > 1) {
            setTimeout(() => {
              setCardKnoxLoaded(true);
            }, 1000);
          }
          setLoadCount(loadCount + 1);
        }}
        data-ifields-id={type}
        data-ifields-placeholder={placeholder}
        src={`https://cdn.cardknox.com/ifields/${CARDKNOX_IFIELDS_VERSION}/ifield.htm`}
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          overflow: "hidden",
          border: "none",
          width: "100%"
        }}
      ></iframe>
    );
  };

  return (
    <MainContainer className={`${setClassName} card-knox-main`}>
      <Container>
        <InputWrapper>
          <InputContainerGrid
            setBorder={
              (ccServerError || cardKnox["card-number"].touched) &&
              !cardKnox.cardNumberIsValid &&
              !cardKnox["card-number"].initialTouch
                ? "solid 1px rgba(238, 80, 80, 0.48)"
                : cardKnox["card-number"].isFocused
                ? "solid 2px #1f2021"
                : ""
            }
          >
            <Image src="https://cdn.cardcash.com/website/ui/elements/physical-card.svg" />
            <FieldContainer
              setVisibility={cardKnox.loaded ? "initial" : "hidden"}
            >
              {loadIframe("card-number")}
              <Field
                name="xCardNum"
                id="xCardNum"
                dataIfieldsId="card-number-token"
                component={renderField}
              />
            </FieldContainer>
          </InputContainerGrid>
          <ErrorContainer>
            {(ccServerError || cardKnox["card-number"].touched) &&
              !cardKnox.cardNumberIsValid &&
              !cardKnox["card-number"].initialTouch && (
                <div>Enter a valid Credit card</div>
              )}
          </ErrorContainer>
          <Title>
            {cardKnox.cardNumberIsValid && !cardKnox.cardNumberIsEmpty && (
              <div>Credit card number</div>
            )}
          </Title>
        </InputWrapper>
        <FieldGrid>
          <InputWrapper>
            <InputContainer>
              <Field
                autoComplete="cc-exp"
                name="creditCardInformation.ExpirationDate"
                label="ExpirationDate"
                component={RenderFormFieldNew}
                type="text"
                placeholder="MM/YY"
                validate={expirationDate}
                normalize={normalizeMonthAndYear}
              />
            </InputContainer>
          </InputWrapper>
          <InputWrapper>
            <InputContainerGrid
              setBorder={
                (ccServerError || cardKnox.cvv.touched) &&
                (cardKnox.cvvIsValid === false ||
                  cardKnox.cvvIsProvenInvalid) &&
                !cardKnox.cvv.initialTouch
                  ? "solid 1px rgba(238, 80, 80, 0.48)"
                  : cardKnox.cvv.isFocused
                  ? "solid 2px #1f2021"
                  : ""
              }
            >
              <LockImage src="https://cdn.cardcash.com/website/partners/starbucks/locked@svg.svg" />
              <FieldContainer
                setVisibility={cardKnox.loaded ? "initial" : "hidden"}
              >
                {loadIframe("cvv")}

                <Field
                  name="xCVV"
                  id="xCVV"
                  dataIfieldsId="cvv-token"
                  component={renderField}
                />
              </FieldContainer>
            </InputContainerGrid>
            <ErrorContainer>
              {(ccServerError || cardKnox.cvv.touched) &&
                (cardKnox.cvvIsValid === false ||
                  cardKnox.cvvIsProvenInvalid) &&
                !cardKnox.cvv.initialTouch && <div>Enter cvv</div>}
            </ErrorContainer>
            <Title>
              {cardKnox.cvvIsValid &&
                !cardKnox.cvvIsProvenInvalid &&
                !cardKnox.cvvIsEmpty && <div>CVV</div>}
            </Title>
          </InputWrapper>
        </FieldGrid>
        <CheckboxContainer>
          <StyledCheckbox
            name={checkboxName}
            text={"Make this my default payment method"}
          />
        </CheckboxContainer>
        {billingCheckboxName && (
          <>
            {!missingInfo ? (
              <CheckboxContainer>
                <StyledCheckbox
                  name={billingCheckboxName}
                  text={"Use my residence as my billing address"}
                />
              </CheckboxContainer>
            ) : (
              <Header>Billing Address</Header>
            )}
            {!billingValid && (
              <FormSection name="creditBilling">
                <CustomerAddressForm
                  errorFromServer={ccServerError}
                  formData={formData}
                />
              </FormSection>
            )}
          </>
        )}

        <div>
          <DefaultCustomButton
            classes={"main-default-orange-button"}
            type="button"
            disabled={
              !cardKnox.cardNumberIsValid ||
              (cardKnox.cvvIsValid === false && !cardKnox.cvvIsProvenValid) ||
              cardKnox.cvvIsProvenInvalid ||
              invalid
            }
            buttonType={buttonType}
            name="submit"
            setId={"submit-btn"}
          >
            <span>{submitText}</span>
          </DefaultCustomButton>
        </div>
      </Container>

      {(!cardKnox.loaded || cardKnoxSubmitting) && <SmallSpinner />}
    </MainContainer>
  );
};

const renderField = ({ input, id, dataIfieldsId }) => (
  <input data-ifields-id={dataIfieldsId} {...input} id={id} type="hidden" />
);

export default withRouter(
  connect(
    state => ({
      cardKnox: state.cardKnox
    }),
    dispatch => ({
      updateErrorMsg: msg =>
        dispatch(defaultAction(UPDATE_BUY_CART_ERROR_MSG, msg)),
      handleCardKnoxForm: obj => dispatch(handleCardKnoxForm(obj)),
      clearForm: () => dispatch(defaultAction(CLEAR_CARD_KNOX)),
      getCardKnoxState: () => dispatch(getCardKnoxState()),
      getCardknoxData: () => dispatch(getCardknoxData()),
      setCardKnoxSubmission: bool =>
        dispatch(defaultAction(SET_CARD_KNOX_SUBMITTING, bool)),
      setCardKnoxLoaded: bool =>
        dispatch(defaultAction(SET_CARD_KNOX_LOADED, bool))
    })
  )(CardKnox)
);
